export default {
  title: 'Virksomhedsoversigt',
  description: 'Velkommen tilbage, {{name}}! Her er, hvad der sker med din markedsføring.',
};
